// extracted by mini-css-extract-plugin
export default {"component":"taskList__component___DihcN"};